import { normalizeCompanyDomain } from "./getCompanyDomain";

const DEFAULT_LOGO_DEV_BASE_URL = "https://img.logo.dev/";

const getLogoDevUrls = () => {
  const rawUrls = process.env.REACT_APP_LOGO_DEV_URLS;

  if (!rawUrls) {
    return {};
  }

  try {
    return JSON.parse(rawUrls);
  } catch {
    return {};
  }
};

const normalizeBaseUrl = (baseUrl) =>
  baseUrl?.endsWith("/") ? baseUrl : `${baseUrl}/`;

const normalizeCompanyName = (company) => {
  const normalized = (company || "company").replace(/[^a-zA-Z0-9]/g, "");
  return `${normalized || "company"}.default`;
};

export const buildLogoDevUrl = (
  domain,
  company,
  format = "webp",
  theme = "light",
  size,
  greyscale,
  retina,
  fallback
) => {
  const token = process.env.REACT_APP_LOGO_DEV_TOKEN;
  // Normalize so full URLs don't bypass img.logo.dev via `new URL()`.
  const normalizedDomain = normalizeCompanyDomain(domain);

  if (!token && !normalizedDomain) {
    return "";
  }

  const logoDevUrls = getLogoDevUrls();
  const baseUrl = normalizeBaseUrl(
    logoDevUrls.baseUrl || DEFAULT_LOGO_DEV_BASE_URL
  );
  const name = normalizedDomain || normalizeCompanyName(company);
  const url = new URL(name, baseUrl);

  if (token) {
    url.searchParams.append("token", token);
  }

  url.searchParams.append("format", format);
  url.searchParams.append("theme", theme);

  if (retina !== undefined)
    url.searchParams.append("retina", retina.toString());
  if (size) url.searchParams.append("size", size.toString());
  if (greyscale !== undefined) {
    url.searchParams.append("greyscale", greyscale.toString());
  }
  if (fallback) url.searchParams.append("fallback", fallback);

  return url.toString();
};
